/*
* Copyright (c) 2018 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name:	Greenlight.js
*
* Description:	Generic Greenlight JavaScript code.
*
* History:		10-JUL-17	J Fuller		Initial implementation.
*				22-NOV-17	M Sherer		Changes for the Greenlight Annotation Module (DR207).
*				14-FEB-18	J Fuller		Greenlight enhancements to remove existing canvases.
*				14-DEC-18	P Dickson		Implemented SVG documents.
*				08-OCT-18   R Pavolas       Refactored bubble calls. (DR158989)
*				12-OCT-18	H Tapp			Modified Rotate to handle anticlockwise direction (GL205006).
*				16-OCT-18	D Tregoiing	    Added methods for drawing labels to the screen.
*				04-DEC-18   R Pavolas       Added a method to get Canvas by ID name.
*				21-JAN-19	M Sherer		Fix to make sure all annotations are closed during a doc event.
*				23-APR-19   J Fuller        Updated to render tech tools with office docs.
*				18-DEC-19	S Norman		Updated Greenlight to hide approval information determined by a boolean passed from the calling application. (Feature 43023 Greenlight - Hide Approval Information)
 *				05-FEB-20	R Pavolas		Changed url for updating user preferences.
*/

(function () {

	"use strict";

	/**
	 * Creates a new Viewer
	 * This is equivalent to the approvalEnvironment object within the CopyMagic Solution.
	 * @param {bool} readOnly - Determines if the viewer should be shown in read only mode.
	 * @param {array} compareDocuments - These are the compare documents that will be available to the user.
	 * @param {array} readOnlyApprovals - The approvals requested as read only.
	 * @param {object} onComplete - Deferred object to be resolved when viewer completed loading.
	 * @class
	 */
	function Viewer(readOnly, compareDocuments, readOnlyApprovals, onComplete) {
		
		// Read only Mode.
		this.g_bReadOnly = readOnly;

		// Any compare documents that are available.
		this.g_oaCompareDocuments = compareDocuments;

		// Any approvals that should remain as read only.
		this.g_oReadOnlyApprovals = readOnlyApprovals;

		// Add the events.
		this.g_oEvents = {};

		// The Main Artwork Viewer Canvas.
		this.g_oArtworkViewer = null;
		this.g_oAnnotationViewer = null;

		// The current Compare Mode.
		this.g_oCompareMode = eCompareMode.NoCompare;
		
		// The function to be called on completion of loading.
		this.g_oOnComplete = onComplete;

		// The list of active canvases.
		this.g_oActiveCanvasList = [];

		// If the settings menu is in animation.
		this.g_bSettingsAnimating = false;
	}

	Viewer.prototype.clearCanvasHolder = function (canvasHolder, canvasId) {

		// Remove the current canvases from the holder.
		$("#" + canvasHolder).html("");

		// Loop through each of the canvas in the active canvas list.
		for (var i = 0; i < this.g_oActiveCanvasList.length; i++) {

			// If this canvas is part of the cleared canvas holder, or this is the individual canvas we wish to clear.
			if (this.g_oActiveCanvasList[i].g_oContainer.id == canvasHolder || this.g_oActiveCanvasList[i].g_szCanvasId == canvasId) {

				// Remove the canvas from the active canvas list.
				this.g_oActiveCanvasList.splice(i, 1);
				i--;
			}
		}
	};

	Viewer.prototype.getCanvas = function (canvasId) {

		// Create a variable to hold the canvas.
		var oCanvas = null;

		// Find the requested canvas from the list of active canvases.
		for (var i = 0; i < this.g_oActiveCanvasList.length; i++) {
			if (this.g_oActiveCanvasList[i].g_szCanvasId == canvasId) {
				oCanvas = this.g_oActiveCanvasList[i];
				break;
			}
		}

		// Return the requested canvas.
		return oCanvas;
	};

	/**
	 * Returns the first canvas found with the supplied name.
	 * @param {string} canvasName - the name of the canvas.
	 */
	Viewer.prototype.getCanvasByName = function (canvasName) {
		return $.findfirst(g_oViewer.g_oActiveCanvasList, function (canvas) {
			return canvas.g_szCanvasId == canvasName;
		});
	};

	Viewer.prototype.getArtworkCanvas = function () {

		// Create a variable to hold the canvas list.
		var oArtworkCanvas = [];

		// Find the requested canvas from the list of active canvases.
		for (var i = 0; i < this.g_oActiveCanvasList.length; i++) {
			if (this.g_oActiveCanvasList[i].g_iCanvasType == eCanvasType.Artwork) {
				// If this is not the navigation canvas.
				if (this.g_oActiveCanvasList[i].g_szCanvasId != "navCanvas" && this.g_oActiveCanvasList[i].g_szCanvasId != "navCanvasOverlay") {
					oArtworkCanvas.push(this.g_oActiveCanvasList[i]);
				}
			}
		}

		// Return the artwork canvas.
		return oArtworkCanvas;
	};

	Viewer.prototype.getLinkedArtworkCanvas = function (canvasId) {

		// Create a variable to hold the canvas.
		var oCanvas = null;

		// Find the requested canvas from the list of active canvases.
		for (var i = 0; i < this.g_oActiveCanvasList.length; i++) {
			if (this.g_oActiveCanvasList[i].g_iCanvasType == eCanvasType.Artwork && this.g_oActiveCanvasList[i].g_oAnnotationCanvas != null && this.g_oActiveCanvasList[i].g_oAnnotationCanvas.g_szCanvasId == canvasId) {
				oCanvas = this.g_oActiveCanvasList[i];
				break;
			}
		}

		// Return the requested canvas.
		return oCanvas;
	};

	/**
	 * Change the document to the one that has been selected.
	 * @param {string} optionValue - Selected document value.
	 */
	Viewer.prototype.docChangeEvent = function (oDoc) {
		
		// If we have an active text highlight, end this.
		if (g_oTextTools.g_bHighlightInProgress) {
			g_oTextTools.endhighlight(g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer, false);
		}

		// If we are in text compare mode, get set up for the document change.
		if (g_oTextCompare.g_bTextCompareInProgress) {
			g_oTextCompare.changeDocument();
		}

		// If we still have open annotations, close them.
		if (typeof (g_oAnnotations) !== "undefined") {
			g_oAnnotations.closeActiveAnnotations();
		}

		// If the copy magic slide out is shown, hide this.
		if ($("#divCopyMagicContainer").css("display") != "none") {
			g_oSVGCopyMagic.hideCopyMagicSlideOut();
		}

		// If we are showing the archive module, remove this.
		if (g_oArchive.g_ArchiveDocument > 0) {
			g_oArchive.removeArchiveLock();
		}

		// If the doc isn't defined it was selected via the combo box.
		if ($.isEmptyObject(oDoc) || oDoc === null) {
			// Get the index of the approval document combo control.
			var oComboControl = comboControl_GetControlById("approvalNameComboControl", false);

			// If the combo control has been found and a document has been selected.
			if (oComboControl != null && oComboControl.selectedDocumentIndex != -1) {

				// Get the selected approval document.
				oDoc = oComboControl.documents[oComboControl.selectedDocumentIndex].document;

				// Determine the page number required.
				var iPageNumber = 1;

				// If the current document has multiple pages.
				if (oDoc.pages.length > 1) {

					// Get the selected document page.
					var oPage = oDoc.pages[oComboControl.selectedPageIndex];

					// Set the page number to the selected page number.
					iPageNumber = oPage.documentPageNumber;
				}

				// Setup the viewer with the document.
				g_oViewer.setupViewer(oDoc, iPageNumber);

				// If Alignment Mode is Active, we don't want to render the Tech Tools menu.
				if (!g_oCompare.g_bAlignmentModeActive && !g_oTextCompare.g_bTextCompareInProgress) {
					g_oViewer.RenderTechTools(oDoc);
				}
			}
		}
		// Doc is defined it's been manually selected.
		else {
			g_oViewer.setupViewer(oDoc.document, 1);
			g_oViewer.RenderTechTools(oDoc.document);
		}

		// If we're in MultiView & not in compare, show the approval tools.
		if (g_bMultiView && $("#divCanvasToolsContainer").css("display") === "none" && !g_oApproval.g_bApprovalInformationHidden) {
			$("#tblBatchApprovalTools").show();
		}
	};

	Viewer.prototype.RenderTechTools = function (oDoc) {
		
		// Hide or Show the correct tech controls.
		if (oDoc.documentType === eDocumentTypes.ThreeD || documentDisplaysAsSVG(oDoc.documentType)) {
			$("#tblTechTools").hide();
		}
		else {
			$("#tblTechTools").show();
			
			// Sub category tech tools.
			if (documentHasSeparations(oDoc.documentType, oDoc.pages.length)) {
				$("#divTechToolsText").show();
				$("#divTechToolsBarcode").show();
				$("#divTechToolsDensity").show();
			}
			else {
				$("#divTechToolsText").hide();
				$("#divTechToolsBarcode").hide();
				$("#divTechToolsDensity").hide();
			}
		}
	};

	/**
	 * Hides or shows the buttons based upon the device size.
	 */
	Viewer.prototype.configureButtons = function () {

		if (g_oViewer.g_oArtworkViewer.g_oDoc.documentType === eDocumentTypes.ThreeD ||
			(g_oViewer.g_oCompareMode != eCompareMode.NoCompare && g_oCompare.g_oCompareViewer.g_oDoc != null && g_oCompare.g_oCompareViewer.g_oDoc.documentType === eDocumentTypes.ThreeD)) {
			// Hide the marquee tool.
			$("#btnZoomMarquee").hide();
		}
		// If the document is not a 3d document.
		else {

			// Show the marquee tool.
			$("#btnZoomMarquee").show();
		}

		// If we are currently finding SVG text.
		if (g_oViewer.c_bFindSVGText) {

			// Clear the SVG search.
			g_oSVGSearch.clearSVGSearch(null, null, false);

			// Stop finding SVG text.
			g_oViewer.c_bFindSVGText = false;
		}

		// If the document is an SVG.
		if (documentDisplaysAsSVG(g_oViewer.g_oArtworkViewer.g_oDoc.documentType)) {

			// Show the SVG tools.
			$("#tblSVGTools").show();
		}
		// If the document is not an SVG.
		else {

			// Hide the SVG tools
			$("#tblSVGTools").hide();
		}

		// If we are in read only mode.
		if (g_oViewer.g_bReadOnly) {

			// Hide the annotate tools if visible.
			if ($("#tblAnnotateTools").is(":visible")) {
				$("#tblAnnotateTools").hide();
			}
		}
		// If we are not in read only mode.
		else {
			// Show the annotation tools.
			$("#tblAnnotateTools").show();
		}
	};

	/**
	 * Finalize the rendering of the initial image.
	 */
	Viewer.prototype.finalizeRenderingImage = function () {
		if (g_oViewer.g_oOnComplete != null) {
			g_oViewer.g_oOnComplete.resolve();
			g_oViewer.g_oOnComplete = null;
		}
	};

	/**
	 * Pans across the canvas.
	 */
	Viewer.prototype.pan = function (oSyncCanvas) {
		this.g_oArtworkViewer.pan(oSyncCanvas);
	};

	/**
	 * Registers the viewers events.
	 * @param {object} oEventService - The event service we are registering the events to.
	 */
	Viewer.prototype.registerEvents = function (oEventService) {
		this.g_oEvents = oEventService;
		this.g_oEvents.subscribe("changeDoc", this.docChangeEvent);
	};

	/**
	 * On Window Resize event.
	 */
	Viewer.prototype.resizeWindow = function () {
		this.g_oArtworkViewer.resize();
	};

	/**
	 * Rotates a canvas.
	 * @param {int} iRotDegrees - Used to specify the degrees of rotation
	 */
	Viewer.prototype.rotate = function (oSyncCanvas, iRotDegrees) {

		// Perform the rotation on the main canvas.
		this.g_oArtworkViewer.rotateAnimate(iRotDegrees);

		// Perform the rotation on any sync canvas.
		for (var i = 0; i < oSyncCanvas.length; i++) {
			oSyncCanvas[i].rotateAnimate(iRotDegrees);
		}
	};

	/**
	 * Draws a label to the screen
	 * @param {number} x - The x coordinate of the label
	 * @param {number} y - The y coordinate of the label
	 * @param {string} text - The text of the label
	 */
	Viewer.prototype.DrawLabel = function (x, y, text) {
		var boxHeight = 25;
		var boxWidth = 135;
		var context = this.getCanvas("CompareAnnotationViewer").g_oContext;

		context.fillStyle = (g_oSettings.c_iSkinType == 0 ? '#2c2121' : '#fbfaf9');
		context.fillRect(x, y, boxWidth, boxHeight);

		context.font = "12px Varela Round, sans-serif";
		context.fillStyle = (g_oSettings.c_iSkinType == 0 ? 'White' : 'Black');
		context.fillText(text, x + 10, y + 15);
	};

	/**
	 * Sets up the approval document combo control.
	 */
	Viewer.prototype.setupApprovalDocument = function (oCompareDocs, iSelectedDocumentId) {
		
		// Create the approval document combo control.
		comboControl_CreateNewControl("approvalNameComboControl", "divApprovalName", g_oViewer.c_szApprovalDocument, oCompareDocs, true, "EventService.publish('changeDoc')", g_oViewer.c_szChangeCurrentDocument, "", 0);

		// Get the index of the approval document control.
		var iControlIndex = comboControl_GetControlById("approvalNameComboControl", true);

		// Get the index of the approval document.
		var iDocumentIndex = comboControl_GetDocumentById(iControlIndex, iSelectedDocumentId, true);

		//  Check that we have found the desired document.
		if (iDocumentIndex == null) {

			// Display an error and default to the first document in the list.
			g_oGreenlightMessages.displayErrorBubble(g_oViewer.c_szInvalidDocument);
			iDocumentIndex = 0;
		}

		// Set the current document as the selected control item.
		comboControl_SelectOption(iControlIndex, iDocumentIndex, -1, false);
	};

	/**
	 * Sets up the annotations div. Left side bar.
	 */
	Viewer.prototype.setupAnnotationsDiv = function () {

		// Show the annotations container if we are not in alignment mode.
		if (!g_oCompare.g_bAlignmentModeActive && !g_oTextCompare.g_bTextCompareInProgress) {
			$("#divAnnotationsContainer").css("display", "");
		}

		// Make sure the top of the annotations menu lines up beneath the approval status bar.
		$("#divAnnotationsContainer").css("top", ($("#divViewerCell").offset().top));

		// Slide the menu to the correct position.
		slideDiv($("#divAnnotationsContainer"), true, false);
	};

	/**
	 * Setup the viewer object.
	 * @param {object} - The document we are setting up in the viewer.
	 */
	Viewer.prototype.setupViewer = function (oDocument, pageNumber) {
		
		// Select the document and page.
		var _doc = oDocument;
		var _pageNumber = pageNumber;

		// Clear the current canvases.
		g_oViewer.clearCanvasHolder("divCanvasHolder", "");
		g_oViewer.clearCanvasHolder("divCompareCanvasHolder", "");
		g_oViewer.clearCanvasHolder("divDifferencesCanvasHolder", "");

		// If this is a 3D approval.
		if (_doc !== null && _doc.documentType == eDocumentTypes.ThreeD) {

			// Setup the Annotation Viewer.
			this.g_oAnnotationViewer = new window.Canvas("divCanvasHolder", "AnnotationViewer", "annotationViewer", null, 0, null, false, eCanvasType.Annotation);

			// Setup the Artwork Canvas.
			this.g_oArtworkViewer = new window.ThreeDCanvas("divCanvasHolder", "ArtworkViewer", _doc, 1, this.g_oAnnotationViewer, true, eCanvasType.Artwork);

			// Hide the separations container and page tools.
			$("#divSepContainer").hide();
			$("#tblPageTools").hide();
		}
		// If this is a 2D approval.
		else {
			// Setup the Annotation Viewer.
			this.g_oAnnotationViewer = new window.Canvas("divCanvasHolder", "AnnotationViewer", "annotationViewer", null, 0, null, false, eCanvasType.Annotation, 2);

			// Setup the Artwork Canvas.
			this.g_oArtworkViewer = new window.Canvas("divCanvasHolder", "ArtworkViewer", "viewer", _doc, _pageNumber, this.g_oAnnotationViewer, true, eCanvasType.Artwork, 1);

			// Update the page number.
			$("#divPageSelectCounter").text((pageNumber > 1 ? pageNumber : 1) + "/" + oDocument.pages.length);

			// Setup the annotations div.
			g_oViewer.setupAnnotationsDiv();

			// Show the page tools if this document has multiple pages.
			if (oDocument.pages.length > 1) {
				$("#tblPageTools").show();
			}
			// Hide the page tools if this document does not have multiple pages.
			else {
				$("#tblPageTools").hide();
			}
		}

		// Set the main viewers on the annotation script.
		g_oAnnotations.g_oArtworkViewer = this.g_oArtworkViewer;
		g_oAnnotations.g_oAnnotationViewer = this.g_oAnnotationViewer;

		// Set the main viewers on the tech tools script.
		g_oTechTools.g_oArtworkViewer = this.g_oArtworkViewer;
		g_oTechTools.g_oAnnotationViewer = this.g_oAnnotationViewer;

		// Set the main viewers on the compare script.
		g_oCompare.g_oArtworkViewer = this.g_oArtworkViewer;
		g_oCompare.g_oAnnotationViewer = this.g_oAnnotationViewer;

		// Configure the buttons.
		this.configureButtons();

		// If a specific page is required.
		if (pageNumber > 1) {

			// Change the approval to use the new page number.
			g_oViewer.g_oArtworkViewer.g_iCurrentPage = pageNumber;
			g_oViewer.g_oArtworkViewer.changeCurrentPage();
			EventService.publish("changeCurrentPage", g_oViewer.g_oArtworkViewer, g_oViewer.g_oAnnotationViewer);
		}

		// If we have an active compare mode.
		if (g_oViewer.g_oCompareMode != eCompareMode.NoCompare) {
			g_oCompare.activateCompare(g_oViewer.g_oCompareMode, g_oCompare.g_oCompareDocument, g_oCompare.g_oComparePage);
		}
	};

	/**
	 * Toggles the Annotations div.
	 */
	Viewer.prototype.toggleAnnotationsDiv = function () {

		// Slide the menu.
		slideDiv($("#divAnnotationsContainer"), true, true);

		// Update the user settings.
		g_oSettings.syncSettings();
	};

	/**
	 * Toggles the separations div.
	 */
	Viewer.prototype.toggleSeparationsDiv = function () {

		// Slide the menu.
		slideDiv($("#divSepContainer"), false, true);

		// Update the user settings.
		g_oSettings.syncSettings();
	};

	/**
	 * Zooms the chosen canvas in.
	 */
	Viewer.prototype.zoomIn = function (oSyncCanvas) {

		// Perform the zoom in on the main canvas.
		this.g_oArtworkViewer.g_oCanvasZoom.zoomIn();

		// Perform the zoom in on any sync canvas.
		for (var i = 0; i < oSyncCanvas.length; i++) {
			oSyncCanvas[i].g_oCanvasZoom.zoomIn();
		}
	};

	/**
	 * Zoom Marquee Event Start.
	 */
	Viewer.prototype.marqueeZoom = function (oSyncCanvas) {
		this.g_oArtworkViewer.g_oCanvasZoom.marqueeZoom(oSyncCanvas);
	};

	/**
	 * Zooms the chosen canvas out.
	 */
	Viewer.prototype.zoomOut = function (oSyncCanvas) {

		// Perform the zoom out on the main canvas.
		this.g_oArtworkViewer.g_oCanvasZoom.zoomOut();

		// Perform the zoom out on any sync canvas.
		for (var i = 0; i < oSyncCanvas.length; i++) {
			oSyncCanvas[i].g_oCanvasZoom.zoomOut();
		}
	};

	/**
	 * Reset the Zoom of a canvas.
	 */
	Viewer.prototype.zoomReset = function (oSyncCanvas) {

		// Perform the zoom reset on the main canvas.
		this.g_oArtworkViewer.g_oCanvasZoom.zoomReset();

		// Perform the zoom reset on any sync canvas.
		for (var i = 0; i < oSyncCanvas.length; i++) {
			oSyncCanvas[i].g_oCanvasZoom.zoomReset();
		}
	};

	// Add the viewer object to the window.
	window.Viewer = Viewer;
}());